// eslint-disable-next-line no-shadow
export enum CourseLibraryPermissions {
  DOWNLOAD_COURSE_LIBRARY = 'admin.coursebuilder.courselibrary.download',
  VIEW_COURSE_LIBRARY = 'admin.coursebuilder.courselibrary.view',
  DOWNLOAD_VIDEO_LIBRARY = 'admin.coursebuilder.videolibrary.download',
  VIEW_VIDEO_LIBRARY = 'admin.coursebuilder.videolibrary.view',
}
